import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { userPageValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import { Helmet } from "react-helmet-async"
import {
  getAllParentsQuery,
  createParentMutation,
  deleteParentMutation,
  updateParentMutation,
} from "./Queries"

class Users extends Component {
  constructor(props) {
    super(props)
    this.state = {
      manageModal: false,
      Label: "",
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [10, 50, 100],
      pageLimit: 10,
      totalCount: 0,
      keyField: "ID",
      viewModal: false,
      userList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 10,
      },
      user: {
        taskName: "",
        ageGroupId: "",
        icon: "",
      },
      columns: [
        {
          name: "Name",
          selector: row => row.name,
          sortable: true,
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: "Mobile Number",
          selector: row => row.mobileNumber,
          sortable: true,
          cell: row => <span>{row.mobileNumber ? row.mobileNumber : ""}</span>,
        },
        // {
        //   name: "Number Of Kids",
        //   selector: "kids",
        //   sortable: true,
        //   cell: row => <span>{row.kids ? row.kids : ""}</span>,
        // },
        {
          name: "Conversion Point",
          selector: row => row.conversionPoints,
          sortable: true,
          cell: row => (
            <span>{row.conversionPoints ? row.conversionPoints : ""}</span>
          ),
        },
        {
          name: "Conversion Money",
          selector: row => row.conversionMoney,
          sortable: true,
          cell: row => (
            <span>{row.conversionMoney ? row.conversionMoney : ""}</span>
          ),
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("view")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllUsers()
  }

  getAllUsers = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllParentsQuery, values)
    var usersValue = response?.data?.getAllParents?.items
    //console.log(usersValue)
    if (usersValue) {
      this.setState({
        isLoading: false,
        userList: usersValue,
        totalPage:
          response?.data?.getAllParents?.pagination?.totalCount /
          response?.data?.getAllParents?.pagination?.pageLimit,
        totalCount: response?.data?.getAllParents?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllUser()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllUsers()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllUsers()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllUsers()
        }
      }
    )
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        user: row,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  handleSubmit = async values => {
    this.state.Label == "Add" ? this.AddAge(values) : this.EditAge(values)
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      user: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      user: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteUser = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteParentMutation, values)
    var userdeleteValue = response?.data
    if (userdeleteValue.deleteParent.status === "Success") {
      SuccessMessage(Message("user.delete"))
      this.getAllUsers()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      userDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.user
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>Users</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  showButton={false}
                  heading={`${"Home"}.${"User List"}`}
                  //buttonText={Message("add.user")}
                  onTextChange={this.searchQueryChanged}
                  //buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.userList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  onSort={this.handleSort}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>

            {/*delete user modal */}
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.user")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        <strong>{this.state.user?.name}</strong>{" "}
                        {Message("user")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => this.deleteUser(this.state.user.id)}
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>

            {/*add / edit users modal */}
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="lg"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.user")
                  : Message("view.user")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={userPageValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("name")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="name"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.mobileNumber")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="mobileNumber"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.conversionPoints")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="conversionPoints"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.conversionMoney")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="conversionMoney"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.spouseName")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="spouseName"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.hasNotification")}</Label>
                              <FormGroup className="custom-control custom-switch mt-1 ms-2">
                                <Input
                                  readOnly
                                  autoComplete="off"
                                  type="checkbox"
                                  className="custom-control-input ms-2"
                                  id="hasNotification"
                                  checked={
                                    values ? values.hasNotification : true
                                  }
                                />
                                <Label
                                  className="custom-control-label"
                                  htmlFor="hasNotification"
                                ></Label>
                              </FormGroup>
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.quizPoint")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="quizPoint"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.taskPoint")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="taskPoint"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.assessmentPoint")}</Label>

                              <Field
                                readOnly
                                autoComplete="off"
                                className="form-control"
                                name="assessmentPoint"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6" xl="6" sm="6" md="6" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label> {Message("user.isRealMoneyUser")}</Label>
                              <FormGroup className="custom-control custom-switch mt-1 ms-2">
                                <Input
                                  readOnly
                                  autoComplete="off"
                                  type="checkbox"
                                  className="custom-control-input ms-2"
                                  id="isRealMoneyUser"
                                  checked={
                                    values
                                      ? values.isRealMoneyUser
                                        ? true
                                        : false
                                      : true
                                  }
                                />
                                <Label
                                  className="custom-control-label"
                                  htmlFor="isRealMoneyUser"
                                ></Label>
                              </FormGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          {this.state.Label == "Add" ? (
                            <Col sm={6} className="required">
                              &nbsp;{Message("mandatory.fields")}
                            </Col>
                          ) : (
                            ""
                          )}
                          <Col sm={6}></Col>
                          <Col sm={12}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                {this.state.Label == "Add" ? (
                                  <Button type="submit" color="primary">
                                    {this.state.Label == "Edit"
                                      ? "Update"
                                      : "Add"}
                                  </Button>
                                ) : (
                                  ""
                                )}

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(Users)
